import type { Language, Translations } from "@/lib/translations";

/*
  The bundled tables for the languages that have one, each its own chunk,
  loaded the first time a reader picks that language. English has none: its
  text is written beside each key at the call site, t("key", "English"), so
  nothing here is ever on the first load (lib/translations.ts says why).
*/
const languageLoaders: Partial<Record<Language, () => Promise<{ default: Partial<Translations> }>>> = {
  fr: () => import("./translations/fr"),
  es: () => import("./translations/es"),
  pt: () => import("./translations/pt"),
  de: () => import("./translations/de"),
  ar: () => import("./translations/ar"),
  tr: () => import("./translations/tr"),
  he: () => import("./translations/he"),
  hi: () => import("./translations/hi"),
  zh: () => import("./translations/zh"),
};

const loaded = new Map<Language, Partial<Translations>>();
const EMPTY: Partial<Translations> = {};

export async function loadStaticLanguage(lang: Language): Promise<Partial<Translations>> {
  const cached = loaded.get(lang);
  if (cached) return cached;
  const loader = languageLoaders[lang];
  if (!loader) return EMPTY;
  const table = (await loader()).default;
  loaded.set(lang, table);
  return table;
}
